export default  {
    'LEAD_URL': 'leads',
    'PROJECT_URL':'projects',
    'COMPANY_URL' :'company',
} 